module.exports = {"441625100":"仙塘镇","441625101":"灯塔镇","441625102":"骆湖镇","441625103":"船塘镇","441625104":"顺天镇","441625105":"上莞镇","441625106":"曾田镇","441625107":"柳城镇","441625108":"义合镇","441625109":"蓝口镇","441625110":"黄田镇","441625111":"叶潭镇","441625112":"黄村镇","441625113":"康禾镇","441625114":"锡场镇","441625115":"新港镇","441625116":"双江镇","441625117":"涧头镇","441625121":"新回龙镇","441625122":"半江镇","441625200":"漳溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441625.json
// module id = 2041
// module chunks = 0